import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { faTimes, faFileAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';

import { ResultsService } from '../../services/results.service';
import { AlertService } from '../alert-service/alert-service';

@Component({
  selector: 'app-modal-view-log',
  standalone: true,
  imports: [FontAwesomeModule, TranslateModule],
  templateUrl: './modal-view-log.component.html',
  styleUrls: ['./modal-view-log.component.scss']
})
export class ModalViewLogComponent implements OnChanges {
  @Input() show = false;
  @Input() interactionId: string = '';
  @Input() resultId: string = '';
  @Output() close = new EventEmitter<void>();

  faTimes = faTimes;
  faFileAlt = faFileAlt;
  faSpinner = faSpinner;

  loading = false;
  logContent: string = '';

  constructor(
    private resultsService: ResultsService,
    private alert: AlertService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show'] && this.show && this.interactionId && this.resultId) {
      this.loadLog();
    }
  }

  loadLog(): void {
    this.loading = true;
    this.logContent = '';

    this.resultsService.getResultLogs(this.interactionId, this.resultId).subscribe({
      next: (response) => {
        this.logContent = response.logs || response.content || 'No log content available.';
        this.loading = false;
      },
      error: (err) => {
        this.alert.showError(err, 'Erro ao carregar o log.');
        this.loading = false;
        this.logContent = 'Erro ao carregar o log.';
      }
    });
  }

  onClose(): void {
    this.close.emit();
  }
}